export default {
    me: {},
    authenticate: false,
}